module.exports = __webpack_public_path__ + "static/media/p4_4.e0db9b61.png";